// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-accordion-section-header.bolt-button {
  padding: 0 8px;
  height: 40px;
  border-radius: 2px;
  text-align: left;
  min-width: 0;
  flex-shrink: 1;
}
.bolt-accordion-section-header.bolt-button:hover {
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}
.bolt-accordion-section-header.bolt-button .bolt-accordion-section-header-content {
  min-width: 0;
}
.bolt-accordion-section-header.bolt-button .bolt-accordion-section-chevron {
  font-size: 0.75rem;
  font-weight: normal;
  margin-left: 8px;
  -ms-transform: transform 100ms linear;
  -moz-transition: transform 100ms linear;
  -webkit-transition: transform 100ms linear;
  transition: transform 100ms linear;
}
.bolt-accordion-section-header.bolt-button .bolt-accordion-section-chevron.rotate {
  -ms-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}

.bolt-accordion-section-content {
  padding: 8px 8px 40px 8px;
  overflow: hidden;
  transform-origin: top left;
  opacity: 1;
}

.bolt-accordion-section-content-enter {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}
.bolt-accordion-section-content-enter.bolt-accordion-section-content-enter-active {
  transition: all 150ms ease-in-out;
  height: initial;
  padding: 8px 8px 40px 8px;
  opacity: 1;
}

.bolt-accordion-section-content-leave.bolt-accordion-section-content-leave-active {
  transition: all 150ms ease-in-out;
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}

/*# sourceMappingURL=Accordion.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui-experimental/src/Components/Accordion/Accordion.scss","webpack://./../azure-devops-ui-experimental/node_modules/azure-devops-ui/Core/_platformCommon.scss","webpack://./../azure-devops-ui-experimental/bin/Components/Accordion/Accordion.css"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,YCyUS;EDxUT,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AEAJ;AFEI;EACI,qCCuHU;ECvHhB,kEAAkE;AFGhE;AEDJ;EACE,YAAY;AFIV;AEFJ;EFIQ,kBC0QW;EDzQX,mBCiSI;ED/RJ,gBAAA;EACA,qCAAA;EACA,uCAAA;EACA,0CAAA;EEHN,kCAAkC;AFK5B;AEHR;EFKY,8BAAA;EACA,+BAAA;EACA,kCAAA;EEHV,0BAA0B;AAC5B;;AAEA;EFOI,yBAAA;EACA,gBAAA;EACA,0BAAA;EELF,UAAU;AACZ;;AAEA;EFOI,SAAA;EACA,cAAA;EACA,iBAAA;EELF,UAAU;AFOR;AELJ;EFOQ,iCAAA;EACA,eAAA;EACA,yBAAA;EELN,UAAU;AACZ;;AAEA;EFSQ,iCAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EEPN,UAAU;AACZ;;AAEA,wCAAwC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
